import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { VendorAdminService } from "../../../services/api/vendor-admin.service";
import { VendorActions } from "../../actions/vendor.actions";
import { FailState } from "../../models/fail-state";

@Injectable()
export class VendorAccountRemoveEffects {
	remove = createEffect(() =>
		this.actions.pipe(
			ofType(VendorActions.account.remove),
			switchMap(() =>
				this.vendorAdminService.accountRemove().pipe(
					map(() => VendorActions.account.removeSuccess()),
					catchError((error) =>
						of(VendorActions.account.removeFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private vendorAdminService: VendorAdminService
	) {}
}
